const CAPTCHA_ERRORS = {
  NOT_INIT: 'К сожалению, проверка на безопастность не была инициализирована, попробуйте еще раз',
  TOKEN_EXPIRED: 'К сожалению, действие признака проверки на безопасность истекло',
  JS: 'К сожалению, возникла ошибка в модули проверки на безопасность',
  NETWORK: 'К сожалению, возникла ошибка с доступом к проверки на безопасность'
}

export function isCaptchaEnable() {
  return process.env.VUE_APP_CAPTCHA_ENABLE === 'True' || process.env.VUE_APP_CAPTCHA_ENABLE === 'true'
}

export function initCaptcha(id, invisible, callback=(token)=>{}, fail=()=>{}) {
  if (!window.smartCaptcha) {
    fail(CAPTCHA_ERRORS.NOT_INIT)
    return null
  }
  try {
    let widgetId = window.smartCaptcha.render(id, {
      sitekey: process.env.VUE_APP_CAPTCHA_KEY,
      invisible: invisible, // Сделать капчу невидимой
      hideShield: true, // Не показывать уведомление об обработке данных
      callback: (token) => {
        callback(token)
      },
    })
    catchErrorWithText(widgetId, CAPTCHA_EVENTS.TOKEN_EXPIRED, CAPTCHA_ERRORS.TOKEN_EXPIRED, fail)
    catchErrorWithText(widgetId, CAPTCHA_EVENTS.JAVASCRIPT_ERROR, CAPTCHA_ERRORS.JS, fail)
    catchErrorWithText(widgetId, CAPTCHA_EVENTS.NETWORK_ERROR, CAPTCHA_ERRORS.NETWORK, fail)
    return widgetId
  } catch (error) {
    fail(error)
    return null
  }
}

export function executeCaptcha(id, fail=()=>{}) {
  if (!window.smartCaptcha) {
    fail(CAPTCHA_ERRORS.NOT_INIT)
  }
  window.smartCaptcha.execute(id);
}


export function resetCaptcha(id, fail=()=>{}) {
  if (!window.smartCaptcha) {
    fail(CAPTCHA_ERRORS.NOT_INIT)
  }
  window.smartCaptcha.reset(id);
}

export const CAPTCHA_EVENTS = {
  CHALLENGE_VISIBLE: 'challenge-visible',
  CHALLENGE_HIDDEN: 'challenge-hidden',
  NETWORK_ERROR: 'network-error',
  JAVASCRIPT_ERROR: 'javascript-error',
  SUCCESS: 'success',
  TOKEN_EXPIRED: 'token-expired'
}

export function subscribeCaptchaEvent(id, event_type, callback=()=>{}, fail=()=>{}) {
  if (!window.smartCaptcha) {
    fail(CAPTCHA_ERRORS.NOT_INIT)
  }
  window.smartCaptcha.subscribe(id, event_type, callback);
}

export function catchErrorWithText(id, error, text, callback=()=>{}) {
  subscribeCaptchaEvent(id, error, () => {
    callback(text)
  }, callback)
}

export function mountCaptcha(final=() => {}, fail=() => {}) {
  if (window.smartCaptcha) {
    final(true)
    return;
  }

  // Создаем и вставляем скрипт
  const script = document.createElement('script');
  script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js';
  script.defer = true;

  script.onload = () => {
    final()
  };

  script.onerror = () => {
    fail('Не удалось загрузить Yandex SmartCaptcha')
    console.error('Не удалось загрузить Yandex SmartCaptcha');
  };

  document.head.appendChild(script);
}
